
import { Component, Vue } from 'vue-property-decorator';

import Form22ProcessHeader from "@/components/process/Form22/components/Form22ProcessHeader.vue";
import Form22CaseInformation from "@/components/process/Form22/components/Form22CaseInformation.vue";
import { form22StatusInfoType } from '@/types/Information/Form22';

@Component({
    components:{
        Form22ProcessHeader,
        Form22CaseInformation
    }
})
export default class StartForm22 extends Vue {

    stepsCompleted = {} as form22StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
